import React, { useEffect, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import { es } from "date-fns/locale/es";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import axios from "axios";
import "mapbox-gl/dist/mapbox-gl.css";
import { URL_BASE } from "../../config/url-server";
import farmService from "../../services/farm-service";
import sectionService from "../../services/section-service";
import lotService from "../../services/lot-service";
import userService from "../../services/user-service";
import DatePicker from "react-datepicker";
import { Divider, Spin } from "antd";
import moment from "moment";
import config from "../../config/config";
import reportServices from "../../services/report-services";
import { ToastContainer, toast } from 'react-toastify';
import timeUtils from "../Utils/timeUtils";
import trackService from "../../services/track-service";

const MapboxComponent = () => {

    const [filtersOpen, setFiltersOpen] = useState(true);
    const [workersOpen, setWorkersOpen] = useState(false);


    const [loading, setLoading] = useState(false);

    const palmColor = "#2dad4f"
    const palmClusteredColor = "#27a548"

    registerLocale("es", es);
    const start_date = moment().add(-config.DAYS_LESS_MAP, 'd').startOf("day").toDate();
    const end_date = moment().endOf("day").toDate();
    const [startDate, setStartDate] = useState(start_date);
    const [endDate, setEndDate] = useState(end_date);
    const [sectionId, setSectionId] = useState("0");
    const [type, setType] = useState("OPERADOR");

    const [lotPalms, setLotPalms] = useState([]); // Puntos de todas las palmas del lote    
    const escoja = [{ _id: 0, name: "-ESCOJA-" }];
    const [listSection, setListSection] = useState(escoja);
    const [listFarms, setListFarms] = useState(escoja);
    const [listLots, setListLots] = useState(escoja);
    const [listUsers, setListUsers] = useState(escoja);
    const [sessionUser, setSessionUser] = useState("admin");

    const listOptions = [
        { id: 1, value: "Solo labores" },
        { id: 0, value: "Labores y track" }
    ]

    ///Aplicaciones por dia
    const [lotId, setLotId] = useState("0");
    const [farmId, setFarmId] = useState("0");
    const [typeUser, setTypeUser] = useState("OPERADOR");

    const userSession = localStorage.getItem("client")
    const clientId = localStorage.getItem("client")
    const accessToken = localStorage.getItem("token")
    const [tracks, setTracks] = useState([]);
    const [lotPolygons, setLotPolygons] = useState([]);
    const [colors, setColors] = useState([]); // Almacenar colores fijos
    const [selectedPoint, setSelectedPoint] = useState(null); // Punto seleccionado para el popup

    //5.391078, -73.869958
    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });


    // ===== PALETA DE COLORES VIBRANTES (fuera del componente) =====
    const TRACK_COLORS = [
    "#E53935", // Rojo
    "#1E88E5", // Azul
    "#8af775", // Verde esmeralda
    "#fb8600", // Naranja
    "#7d0e9c", // Púrpura
    "#F5008F", // Fucsia
    "#00B8D9", // Cian
    "#C0CA33", // Lima
    "#6D4C41", // Marrón
    "#3949AB", // Índigo
    "#f4371e", // Naranja rojizo
    "#23e0cd"  // Verde azulado
];


     const polygonOpacity =0.2
     const polygonColor ="#52d346"






    const getUserColor = (userId) => {
        const id = String(userId ?? "");

        let hash = 0;

        for (let i = 0; i < id.length; i++) {
            hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
        }

        return TRACK_COLORS[hash % TRACK_COLORS.length];
    };




    const getFarmLotPolygons = async (farmId) => {
        if (!farmId || farmId === "0") {
            setLotPolygons([]);
            return;
        }
        try {
            const params = {
                farmId
            };
            const configRequest = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`
                },
                params
            };
            const response = await axios.get(
                URL_BASE + "map/get-farm-polygons",
                configRequest
            );
            const polygons = response?.data?.data || [];
            setLotPolygons(polygons);
        } catch (error) {
            console.error(
                "Error obteniendo polígonos de los lotes:",
                error
            );
            setLotPolygons([]);
        }
    };


    const lotPolygonsGeoJson = useMemo(() => {

        return {
            type: "FeatureCollection",

            features: lotPolygons
                .filter(lot =>
                    lot.lotPolygon?.type === "Polygon" &&
                    lot.lotPolygon?.coordinates?.length > 0
                )
                .map((lot, index) => {

                    return {
                        type: "Feature",

                        geometry: {
                            type: "Polygon",
                            coordinates: lot.lotPolygon.coordinates
                        },

                        properties: {
                            id: lot._id,
                            name: lot.name,
                            lotCode: lot.lotCode,
                            color: polygonColor
                        }
                    };
                })
        };

    }, [lotPolygons]);


    const lotPolygonsLayer = lotPolygons.length > 0 ? (
        <Source
            id="lot-polygons"
            type="geojson"
            data={lotPolygonsGeoJson}
        >
            <Layer
                id="lot-polygons-fill"
                type="fill"
                paint={{
                    "fill-color": ["get", "color"],
                    "fill-opacity": polygonOpacity
                }}
            />

            <Layer
                id="lot-polygons-line"
                type="line"
                paint={{
                    "line-color": ["get", "color"],
                    "line-width": 2,
                    "line-opacity": 0.9,
                    "line-dasharray": [3, 2]
                }}
            />

            <Layer
                id="lot-polygons-label"
                type="symbol"
                layout={{
                    "text-field": ["get", "name"],
                    "text-size": 12,
                    "text-allow-overlap": true
                }}
                paint={{
                    "text-color": "#FFFFFF",
                    "text-halo-color": "#000000",
                    "text-halo-width": 2
                }}
            />
        </Source>
    ) : null;




    // Función para generar colores basados en el ángulo dorado (para muchos tracks)
    const getGoldenAngleColor = (index) => {
        const hue = (index * 137.5) % 360; // Ángulo dorado para distribución uniforme
        return `hsl(${hue}, 80%, 50%)`; // HSL permite colores vibrantes
    };

  

    // Mantener función de respaldo para compatibilidad
    const getRandomDarkColor = () => {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 12)];
        }
        return color;
    };



    const {
        register,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();

    const listType = [
        { _id: "OPERADOR", name: "OPERADOR" },
        { _id: "SUPERVISOR", name: "SUPERVISOR" },
        { _id: "SANIDAD", name: "SANIDAD" },
        { _id: "COSECHA", name: "COSECHA" },
        { _id: "GENERAL", name: "GENERAL" }
    ]

    const getLisFarm = async () => {
        if (farmId == "0") {
            let listado = await farmService.getList();
            if (listado) {
                listado.push({ _id: 0, name: "-ESCOJA-" });
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListFarms(sortedItems);
            }
        }
    };

    const getListSection = async (e) => {
        const code = e.target.value;
        if (code == "0") {
            setListSection(escoja);
            setListLots(escoja);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")

            setFarmId(code);
            await getFarmLotPolygons(code);
            return;
        }
        let listado = await sectionService.getListByFarm(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListSection(sortedItems);
            setValue("section", "0")
            setValue("lot", "0")
            setValue("user", "0")
        }

        setFarmId(code);
        await getFarmLotPolygons(code);
    };

    const getLisLots = async (e) => {
        const code = e.target.value;
        setSectionId(code)
        if (code == "0") {
            setListLots(escoja);
            setValue("lot", "0")
            setValue("user", "0")
            return;
        }
        let listado = await lotService.getListBySection(code);
        listado.push({ _id: 0, name: "-ESCOJA-" });
        if (listado) {
            const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
            setListLots(sortedItems);
            setValue("lot", "0")
            setValue("user", "0")
        }
    };



    const isValidCoordinate = (coord) => {
        return (
            Array.isArray(coord) &&
            coord.length === 2 &&
            !isNaN(parseFloat(coord[0])) &&
            !isNaN(parseFloat(coord[1]))
        );
    };

    const generateExcel = async () => {
        const role = getValues("type")
        const farmId = getValues("farm");
        const lotId = getValues("lot");
        const optionId = getValues("option");
        const sectionId = getValues("section");
        const userId = getValues("user");
        const deadTime = getValues("deadTime");
        let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
        let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

        setLoading(true);
        try {
            let response;
            if (optionId == "1") {
                response = await reportServices.generateTrackingExcel(start, end, farmId, sectionId, lotId, userId, deadTime, role);
            } else {
                response = await reportServices.generateTrackingExcelAll(start, end, farmId, sectionId, lotId, userId, deadTime, role);
            }

            if (response?.error) {
                toast.error("No hay registros", { autoClose: 1600 })
                setLoading(false);
                return;
            }

            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `tracking ${start} - ${end}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    /*const getListUsers = async () => {

        setValue("user", "0")
        console.log(type)
        const userId = "0"
        try {
            let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
            let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

            const response = await trackService.listUsers(start, end, farmId, sectionId, lotId, userId, type)
            const listado = response.data
            if (listado) {
                listado.push({ _id: 0, name: "-ESCOJA-" });
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListUsers(sortedItems);
            }
        } catch (error) { }
    }*/

    const getListUsers = async () => {
        //if (sectionId == "0") return;

        const resp = timeUtils.calculeDifference(startDate, endDate, 10);
        if (resp) return;

        const farmId = getValues("farm");
        const lotId = getValues("lot");
        const userId = "0";

        try {
            const start = moment(startDate).startOf("day").format("YYYY-MM-DD");
            const end = moment(endDate).endOf("day").format("YYYY-MM-DD");

            const response = await trackService.listUsers(
                start, end, farmId, sectionId, lotId, userId, type
            );

            const listado = response.data;

            if (listado) {
                const sortedItems = [...listado]
                    .sort((a, b) => String(a._id).localeCompare(String(b._id)))
                    .map((user, index) => ({
                        ...user,
                        colorIndex: index % TRACK_COLORS.length,
                        trackColor: TRACK_COLORS[index % TRACK_COLORS.length]
                    }));

                sortedItems.sort((a, b) => a.name.localeCompare(b.name));

                sortedItems.unshift({
                    _id: 0,
                    name: "-ESCOJA-",
                    trackColor: null
                });

                setListUsers(sortedItems);
            }
        } catch (error) {
            console.error("Error cargando usuarios:", error);
        }
    };



    const fetchTracks = async () => {
        const sectionId = getValues("section");

        /*if (sectionId == "0") {
            toast.error("Debe seleccionar una sección!", { autoClose: 1800 })
            return
        }*/

        const resp = timeUtils.calculeDifference(startDate, endDate, 15)
        if (resp) {
            toast.error("La diferencia de fechas debe ser máximo de 15 días!", { autoClose: 1800 })
            return;
        }

        try {
            const mode = getValues("type")
            let role = mode
            setTypeUser(mode)

            if (role == "GENERAL") {
                setValue("option", "0")
            }


            const farmId = getValues("farm")
            const lotId = getValues("lot")
            const sectionId = getValues("section")
            const user = getValues("user")
            const option = getValues("option")


            let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
            let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

            const params = { farmId, sectionId, lotId, startDate: start, endDate: end, userId: user, option, role }
            const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` }, params };

            setLoading(true)
            setTracks([]);
            setColors([]);

            const responseLot = await axios.get(URL_BASE + "tracking/visited-lots", config);
            const visitedPalms = responseLot.data.data
            setLoading(false)

            if (!visitedPalms) return;
            if (visitedPalms.length == 0) {
                setLotPalms([])
                setTracks([])
                return;
            }
            setLotPalms(visitedPalms)

            const response = await axios.get(URL_BASE + "tracking/list-track", config);
            const fetchedTracks = response.data.data;

            // Generar colores para los tracks
            /// const generatedColors = getTrackColors(fetchedTracks.length);
            //setColors(generatedColors); // Guardar en el estado



            const userColorMap = {};

            listUsers
                .filter(user => String(user._id) !== "0")
                .forEach(user => {
                    userColorMap[String(user._id)] = user.trackColor;
                });

            console.log(userColorMap);

            const generatedColors = fetchedTracks.map(track => {
                const userId = String(track.userId);
                return userColorMap[userId] || getUserColor(userId);
            });

            setColors(generatedColors);

            if (fetchedTracks.length > 0 && fetchedTracks[0].movements.length > 0) {
                const longitud = fetchedTracks[0].movements[0].location.coordinates[0]
                const latitud = fetchedTracks[0].movements[0].location.coordinates[1]
                if (latitud) {
                    setViewState({
                        latitude: latitud,
                        longitude: longitud,
                        zoom: 18,
                    });
                }
            }

            setTracks(fetchedTracks);
        } catch (error) {
            console.error("Error obteniendo los tracks:", error);
            setLoading(false);
        }
    };



    const deletePoint = async (date, userName, longitude, latitude) => {

        console.log("date:", date)
        console.log("userName:", userName)
        console.log("latitude:", latitude)
        console.log("longitude:", longitude)
        const params = { date, userName, latitude, longitude }
        const response = await trackService.deleteTrackMovement(params)
        if (response.success) {
            toast.success("Realizado")
            setSelectedPoint(null);
            //fetchTracks()
        }
    }





    useEffect(() => {
        getLisFarm();
        const username = localStorage.getItem("username");
        setSessionUser(username)
    }, []);


    useEffect(() => {

        if (!lotPolygonsGeoJson?.features?.length) {
            return;
        }

        const coordinates = [];

        lotPolygonsGeoJson.features.forEach(feature => {

            const rings = feature.geometry.coordinates;

            rings.forEach(ring => {

                ring.forEach(([lng, lat]) => {

                    coordinates.push([lng, lat]);

                });

            });

        });

        if (coordinates.length === 0) {
            return;
        }

        let minLng = coordinates[0][0];
        let maxLng = coordinates[0][0];
        let minLat = coordinates[0][1];
        let maxLat = coordinates[0][1];

        coordinates.forEach(([lng, lat]) => {

            minLng = Math.min(minLng, lng);
            maxLng = Math.max(maxLng, lng);

            minLat = Math.min(minLat, lat);
            maxLat = Math.max(maxLat, lat);

        });

        const centerLng = (minLng + maxLng) / 2;
        const centerLat = (minLat + maxLat) / 2;

        setViewState(prev => ({
            ...prev,
            longitude: centerLng,
            latitude: centerLat,
            zoom: 15
        }));

    }, [lotPolygonsGeoJson]);



    // Crear capa de todas las palmas del lote
    const palmsGeoJson = useMemo(() => ({
        type: "FeatureCollection",
        features: lotPalms
            .filter(p => isValidCoordinate(p.location.coordinates))
            .map((p, index) => ({
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: p.location.coordinates,
                },
                properties: { id: index },
            })),
    }), [lotPalms]);

    const palmsLayer = (
        <Source
            id="palms"
            type="geojson"
            data={palmsGeoJson}
            cluster={true}
            clusterMaxZoom={14}
            clusterRadius={50}
        >
            <Layer
                id="clusters"
                type="circle"
                beforeId={lotPolygonsGeoJson?.features?.length > 0 ? "lot-polygons-label" : undefined}
                filter={["has", "point_count"]}
                paint={{
                    "circle-color": palmClusteredColor,
                    "circle-radius": 15,
                    "circle-stroke-width": 2,
                    "circle-stroke-color": "#000000",
                }}
            />
            <Layer
                id="cluster-count"
                type="symbol"
                filter={["has", "point_count"]}
                layout={{
                    "text-field": "{point_count_abbreviated}",
                    "text-size": 12,
                }}
            />
            <Layer
                id="unclustered-point"
                type="circle"
                beforeId={lotPolygonsGeoJson?.features?.length > 0 ? "lot-polygons-label" : undefined}
                filter={["!", ["has", "point_count"]]}
                paint={{
                    "circle-color": palmColor,
                    "circle-radius": 5,
                    "circle-size": 5,
                    "circle-stroke-width": 1,
                    "circle-stroke-color": "#000000",
                }}
            />
        </Source>
    );

    // ===== SOLUCIÓN 3: Una sola fuente para todas las líneas =====
    // Crear una sola fuente GeoJSON para todas las líneas
    const linesGeoJson = useMemo(() => ({
        type: "FeatureCollection",
        features: tracks.map((track, index) => ({
            type: "Feature",
            geometry: {
                type: "LineString",
                coordinates: track.movements
                    .map(movement => movement.location.coordinates)
                    .filter(coord => isValidCoordinate(coord))
            },
            properties: {
                trackIndex: index,
                color: colors[index] || getRandomDarkColor()
            }
        })).filter(feature => feature.geometry.coordinates.length > 1) // Solo líneas con al menos 2 puntos
    }), [tracks, colors]);

    // Capa de líneas (una sola capa para todos los tracks)
    const linesLayer = tracks.length > 0 && linesGeoJson.features.length > 0 ? (
        <Source id="tracks-lines" type="geojson" data={linesGeoJson}>
            <Layer
                id="track-lines"
                type="line"
                beforeId="movement-points"
                paint={{
                    "line-color": ["get", "color"],
                    "line-width": 4
                }}
            />
        </Source>
    ) : null;

    // Crear marcadores (puntos)
    const markersGeoJson = useMemo(() => ({
        type: "FeatureCollection",

        features: tracks.flatMap((track, trackIndex) =>
            track.movements.map((movement, movementIndex) => ({
                type: "Feature",

                geometry: {
                    type: "Point",
                    coordinates: movement.location.coordinates,
                },

                properties: {
                    trackIndex,
                    movementIndex,

                    isFirst: movementIndex === 0,
                    isLast: movementIndex === track.movements.length - 1,

                    fillColor: movement.color || "#FFFFFF",
                    strokeColor: colors[trackIndex] || "#000000",
                },
            }))
        ),
    }), [tracks, colors]);

    // Capa de puntos (se renderizará después de las líneas automáticamente)
    const movementLayer = tracks.length > 0 ? (
        <Source
            id="movements"
            type="geojson"
            data={markersGeoJson}
        >

            {/* PUNTOS NORMALES */}
            <Layer
                id="movement-points"
                beforeId={
                    lotPolygonsGeoJson?.features?.length > 0
                        ? "lot-polygons-label"
                        : undefined
                }
                type="circle"

                filter={[
                    "all",
                    ["!", ["get", "isFirst"]],
                    ["!", ["get", "isLast"]]
                ]}

                paint={{
                    "circle-color": ["get", "fillColor"],
                    "circle-stroke-color": ["get", "strokeColor"],
                    "circle-stroke-width": 2,
                    "circle-radius": 5,
                }}
            />

            {/* ESTRELLA INICIAL */}
            <Layer
                id="movement-first"
                type="symbol"

                filter={[
                    "==",
                    ["get", "isFirst"],
                    true
                ]}

                layout={{
                    "text-field": "✦",
                    "text-size": 24,
                    "text-allow-overlap": true,
                    "text-ignore-placement": true,
                }}

                paint={{
                    "text-color": "#ffffff",
                    "text-halo-color": "#000000",
                    "text-halo-width": 1,
                }}
            />

            {/* ESTRELLA FINAL ★ ✦*/}
            <Layer
                id="movement-last"
                type="symbol"

                filter={[
                    "==",
                    ["get", "isLast"],
                    true
                ]}

                layout={{
                    "text-field": "✦",
                    "text-size": 24,
                    "text-allow-overlap": true,
                    "text-ignore-placement": true,
                }}

                paint={{
                    "text-color": "#000000",
                    "text-halo-color": "#FFFFFF",
                    "text-halo-width": 1,
                }}
            />

        </Source>
    ) : null;

    const handleMapClick = (event) => {
        // const feature = event.features?.find(f => f.layer.id === "movement-points");

        const feature = event.features?.find(
            f =>
                f.layer.id === "movement-points" ||
                f.layer.id === "movement-first" ||
                f.layer.id === "movement-last"
        );

        console.log("Feature clicked:", feature);
        if (feature && feature.properties) {
            const { trackIndex, movementIndex } = feature.properties;

            console.log(trackIndex, movementIndex);
            const track = tracks[trackIndex];
            const movement = track?.movements?.[movementIndex];

            if (track && movement) {
                setSelectedPoint({ track, movement });
            }
        }
    };



    useEffect(() => {
        getListUsers();
    }, [startDate, endDate, sectionId, farmId, sectionId, type]);




    return (
        <div className="row">
            <ToastContainer />


            <div className="col-12 col-sm-2">
                {/* ACORDEÓN 1: FILTROS */}
                <div className="card mb-2">
                    <button
                        type="button"
                        className="btn btn-light text-start d-flex justify-content-between align-items-center fw-bold"
                        onClick={() => setFiltersOpen(!filtersOpen)}
                        aria-expanded={filtersOpen}
                    >
                        <span>
                            <i className="bi bi-funnel me-2" />
                            Filtros track
                        </span>

                        <i className={`bi ${filtersOpen ? "bi-chevron-up" : "bi-chevron-down"}`} />
                    </button>

                    {filtersOpen && (
                        <div className="card-body p-2">
                            <form className="form-react">
                                <div className="row">
                                    {/* 
                          Conserva aquí todos tus campos actuales:
                          Tipo, Finca, Sección, Lote, Desde, Hasta,
                          Usuario, Visualizar y Tiempo muerto.
                        */}

                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Tipo</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("type")}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                setType(value)
                                                if (value == "GENERAL") {
                                                    setValue("option", "0")
                                                }
                                                else {
                                                    setValue("option", "1")
                                                }

                                            }}
                                        >
                                            {listType.map((option) => (
                                                <option key={option._id} value={option._id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Finca</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("farm")}
                                            onChange={(e) => getListSection(e)}
                                        >
                                            {listFarms.map((option) => (
                                                <option key={option._id} value={option._id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="  col-12 col-sm-12">
                                        <label className="text-secondary fw-bold">Sección</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("section")}
                                            onChange={(e) => getLisLots(e)}
                                        >
                                            {listSection.map((option) => (
                                                <option key={option._id} value={option._id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Lote</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("lot")}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setLotId(value);
                                            }}
                                        >
                                            {listLots.map((option) => (
                                                <option key={option._id} value={option._id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Desde</label>
                                        <br />
                                        <DatePicker
                                            {...register("startDate")}
                                            locale="es"
                                            dateFormat="yyyy-MM-dd"
                                            className="form-control text-secondary"
                                            selected={startDate}
                                            onChange={(date) => {
                                                setStartDate(date)
                                                setEndDate(date)
                                            }}
                                        />
                                    </div>

                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Hasta</label>
                                        <br />
                                        <DatePicker
                                            {...register("endDate")}
                                            locale="es"
                                            dateFormat="yyyy-MM-dd"
                                            className="form-control text-secondary"
                                            selected={endDate}
                                            onChange={(date) => setEndDate(date)}
                                        />
                                    </div>

                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Usuario</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("user")}
                                        >
                                            {listUsers.map((option) => (
                                                <option key={option._id} value={option._id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Visualizar</label>
                                        <select
                                            className="form-control text-secondary"
                                            {...register("option")}
                                        >
                                            {listOptions.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.value}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className=" col-12">
                                        <label className="text-secondary fw-bold">Tiempo muerto (min)</label>
                                        <input
                                            type="number"
                                            className="form-control text-secondary"
                                            {...register("deadTime")}
                                        />
                                    </div>

                                    {/* Botón Buscar */}
                                    <div className="col-12 mt-2">
                                        <Spin spinning={loading}>
                                            <button
                                                className="btn btn-primary w-100"
                                                type="button"
                                                onClick={() => fetchTracks()}
                                            >
                                                <i className="bi bi-search fa-lg me-2" />
                                                Buscar
                                            </button>
                                        </Spin>
                                    </div>

                                    {/* Botón Exportar */}
                                    <div className="col-12 mt-2">
                                        <Spin spinning={loading}>
                                            <button
                                                className="btn btn-info w-100"
                                                type="button"
                                                onClick={() => generateExcel()}
                                            >
                                                <i className="bi bi-file-earmark-text fa-lg me-2" />
                                                Exportar
                                            </button>
                                        </Spin>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}
                </div>

                {/* ACORDEÓN 2: TRABAJADORES */}
                <div className="card mb-2">
                    <button
                        type="button"
                        className="btn btn-light text-start d-flex justify-content-between align-items-center fw-bold"
                        onClick={() => setWorkersOpen(!workersOpen)}
                        aria-expanded={workersOpen}
                    >
                        <span>
                            <i className="bi bi-people me-2" />
                            Trabajadores
                            <span className="badge bg-primary ms-2">
                                {listUsers.filter(user => String(user._id) !== "0").length}
                            </span>
                        </span>

                        <i className={`bi ${workersOpen ? "bi-chevron-up" : "bi-chevron-down"}`} />
                    </button>

                    {workersOpen && (
                        <div
                            className="card-body p-2"
                            style={{
                                maxHeight: "45vh",
                                overflowY: "auto"
                            }}
                        >
                            {listUsers.filter(user => String(user._id) !== "0").length === 0 ? (
                                <p className="text-muted small mb-0">
                                    Selecciona los filtros y consulta los recorridos.
                                </p>
                            ) : (
                                listUsers
                                    .filter(user => String(user._id) !== "0")
                                    .map(user => (
                                        <div
                                            key={user._id}
                                            className="d-flex align-items-center gap-2 py-2 border-bottom"
                                        >
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "22px",
                                                    height: "5px",
                                                    backgroundColor: user.trackColor,
                                                    borderRadius: "3px",
                                                    flexShrink: 0
                                                }}
                                            />

                                            <span
                                                className="small text-break"
                                                title={user.name}
                                            >
                                                {user.name}
                                            </span>
                                        </div>
                                    ))
                            )}
                        </div>
                    )}
                </div>
            </div>


            <div className="col-12 col-sm-10">
                <Map
                    onClick={handleMapClick}
                    interactiveLayerIds={[
                        "movement-points",
                        "movement-first",
                        "movement-last"
                    ]}
                    {...viewState}
                    onMove={evt => setViewState(evt.viewState)}
                    style={{ width: "100%", height: "100vh" }}
                    mapStyle="mapbox://styles/mapbox/satellite-v9"
                    mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
                >
                    <NavigationControl position="top-left" />


                    {/* Capa de poligonos */}
                    {lotPolygonsLayer}

                    {/* Capa de palmas (fondo) */}
                    {palmsLayer}

                    {/* Capa de líneas (en medio) */}
                    {linesLayer}

                    {/* Capa de puntos (encima de las líneas) */}
                    {movementLayer}

                    {/* Popup siempre encima de todo */}
                    {selectedPoint && (
                        <Popup
                            longitude={selectedPoint.movement.location.coordinates[0]}
                            latitude={selectedPoint.movement.location.coordinates[1]}
                            onClose={() => setSelectedPoint(null)}
                            closeOnClick={false}
                        >
                            <div>
                                <p className={selectedPoint.movement.lineName ? "d-none" : "text-danger"}><strong>Punto Tracking</strong></p>
                                <p className={selectedPoint.movement.lineName ? "text-success" : "d-none"}><strong>Registro labor</strong></p>
                                <hr style={{ marginTop: "-10px", marginBottom: "4px" }} />
                                <label><strong>Usuario:</strong> {selectedPoint.track.userName}</label><br />
                                <label><strong>Hora:</strong> {new Date(selectedPoint.movement.date).toLocaleString()}</label><br />
                                <label><strong>Lote:</strong> {selectedPoint.movement.lotName}</label><br />
                                <label><strong>GPS:</strong> {selectedPoint.movement.eventType}</label><br />
                                <div className={selectedPoint.movement.lineName ? "" : "d-none"} >
                                    <label><strong>Línea:</strong> {selectedPoint.movement.lineName || "N/A"}</label><br />
                                    <label><strong>Palma:</strong> {selectedPoint.movement.palmName || "N/A"}</label><br />
                                    <label><strong>Detalle:</strong> {selectedPoint.movement.detail || "0"}</label><br />
                                    <div className={typeUser == "OPERADOR" ? "" : ""}>
                                        <label><strong>Cantidad:</strong> {selectedPoint.movement.quantity || "0"}</label><br />
                                        <label><strong>Diferencia:</strong> {selectedPoint.movement.difference || "0"} minutos</label>
                                    </div>
                                </div>


                                <div className={selectedPoint.movement.lineName ? "d-none" : ""} >
                                    <div>
                                        <button
                                            className={sessionUser == "superadmin" ? "btn btn-danger mt-2 w-100" : "d-none"}
                                            onClick={
                                                () => deletePoint(
                                                    selectedPoint.movement.date,
                                                    selectedPoint.track.userName,
                                                    selectedPoint.movement.location.coordinates[0],
                                                    selectedPoint.movement.location.coordinates[1])
                                            }
                                        >
                                            Eliminar punto
                                        </button>
                                    </div>
                                </div>


                            </div>
                        </Popup>
                    )}
                </Map>
            </div>
        </div>
    );
};

export default MapboxComponent;